import { PlusOutlined } from '@ant-design/icons';
import { Button, Col } from 'antd';
import React, { useState } from 'react'
import NYSProgrammeList from './adminconfig/nysprogramme/NYSProgrammeList';

function NYSProgrammeView () {

  const [visible, setVisible] = useState(false);
const [hasUpdated, setHasUpdated] = useState(true);

const showModal = (value) => {
    setVisible(value);
};
  return (
    <>
    <div className="content">
        <Col xs={24}>
            <h1 className="center-align">Manage NYS Programme</h1>
        </Col>
       
        {/* <AddNYSProgramme key={"2"} show={visible} onShow={showModal} setHasUpdated={setHasUpdated}/> */}
        <NYSProgrammeList key={"3"} hasUpdated={hasUpdated} setHasUpdated={setHasUpdated}/>
    </div>
</>
  )
}

export default NYSProgrammeView
